import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { RawSequenceItem } from '@app/models/raw-sequence-item.interface';
import { AuthService } from '@app/services/auth.service';
import { RawSequenceItemHelperService } from '@app/services/helpers/raw-sequence-item-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faCirclePlus,
  faArrowLeft 
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-raw-sequence-items',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class RawSequenceItemsPage {
  public title = 'Raw Sequence Items';
  rawSequenceItems$: Observable<RawSequenceItem[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private rawSequenceItemHelper: RawSequenceItemHelperService,
    public auth: AuthService,
  ) {
    this.rawSequenceItems$ = this.rawSequenceItemHelper.getAll();
  }
}
